import React from 'react';
import { Copy, Loader2, RefreshCw } from 'lucide-react';

const FIELDS = [
  { key: 'subject_line', label: 'Ämnesrad',     max: 60, multiline: false },
  { key: 'preheader',    label: 'Preheader',    max: 90, multiline: false },
  { key: 'hero',         label: 'Hero-text',    max: 0,  multiline: false },
  { key: 'rubrik_1',     label: 'Rubrik 1',     max: 0,  multiline: false },
  { key: 'textblock_1',  label: 'Textblock 1',  max: 0,  multiline: true  },
  { key: 'cta_1',        label: 'CTA 1',        max: 0,  multiline: false },
  { key: 'rubrik_2',     label: 'Rubrik 2',     max: 0,  multiline: false },
  { key: 'textblock_2',  label: 'Textblock 2',  max: 0,  multiline: true  },
  { key: 'cta_2',        label: 'CTA 2',        max: 0,  multiline: false },
];

export default function NewsletterMarketEditor({ market, content, onChange, onCopy, onRegenerate, regenerating }) {
  return (
    <div data-testid={`nl-editor-${market}`} style={{ display: 'grid', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <button
          onClick={onCopy}
          data-testid={`nl-copy-${market}`}
          className="ap-btn-pill"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <Copy size={12} /> Kopiera alla
        </button>
        <button
          onClick={onRegenerate}
          disabled={regenerating}
          data-testid={`nl-regen-${market}`}
          className="ap-btn-pill"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          {regenerating
            ? <><Loader2 size={12} className="ap-progress-spin" /> Regenererar...</>
            : <><RefreshCw size={12} /> Regenerera marknad</>}
        </button>
      </div>

      {FIELDS.map(f => {
        const val = content[f.key] || '';
        const overLimit = f.max > 0 && val.length > f.max;
        return (
          <div key={f.key} data-testid={`nl-field-${market}-${f.key}`}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                {f.label}
              </span>
              {f.max > 0 && (
                <span style={{ fontSize: 11, color: overLimit ? '#ef4444' : 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                  {val.length} / {f.max}
                </span>
              )}
            </div>
            {f.multiline ? (
              <textarea
                rows={4}
                value={val}
                onChange={(e) => onChange(f.key, e.target.value)}
                className="form-input"
                style={{ resize: 'vertical', borderColor: overLimit ? '#ef4444' : undefined }}
              />
            ) : (
              <input
                type="text"
                value={val}
                onChange={(e) => onChange(f.key, e.target.value)}
                className="form-input"
                style={{ borderColor: overLimit ? '#ef4444' : undefined }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export { FIELDS };
